import React, { useState } from 'react';

const TYPE_OPTIONS = [
  { value: 'role', label: 'Roles' },
  { value: 'user', label: 'Users' },
];

export function WorkflowTypeModal({ open, onSave }) {
  const [selected, setSelected] = useState('');
  if (!open) return null;
  return (
    <div className="ca-confirm-modal" role="dialog" aria-modal="true" aria-label="Workflow Type">
      <div className="ca-confirm-modal__dialog">
        <div className="ca-workflow-modal__header">
          <p className="ca-confirm-modal__message" style={{ margin: 0 }}>Workflow Type</p>
          {/* <button type="button" className="ca-workflow-modal__close" aria-label="Close" onClick={onClose}>×</button> */}
        </div>
        <div className="ca-workflow-modal__options">
          {TYPE_OPTIONS.map((option) => (
            <button
              key={option.value}
              type="button"
              className={`ca-workflow-modal__option${selected === option.value ? ' ca-workflow-modal__option--selected' : ''}`}
              onClick={() => setSelected(option.value)}
            >
              {option.label}
            </button>
          ))}
        </div>
        <button
          type="button"
          className="ca-btn ca-btn--primary ca-workflow-modal__save"
          disabled={!selected}
          onClick={() => onSave(selected)}
        >
          Save
        </button>
      </div>
    </div>
  );
}

export function WorkflowChangeModal({ open, onContinue, onClose }) {
  if (!open) return null;
  return (
    <div className="ca-confirm-modal" role="dialog" aria-modal="true" aria-label="Workflow change request">
      <div className="ca-confirm-modal__dialog">
        <div className="ca-workflow-modal__header">
          <p className="ca-confirm-modal__message" style={{ margin: 0 }}>Workflow change request</p>
          <button type="button" className="ca-workflow-modal__close" aria-label="Close" onClick={onClose}>×</button>
        </div>
        <p className="ca-body" style={{ marginBottom: 18 }}>
          Changing the workflow will delete all data entered below. Do you want to continue?
        </p>
        <button type="button" className="ca-btn ca-btn--primary ca-workflow-modal__save" onClick={onContinue}>
          Continue
        </button>
      </div>
    </div>
  );
}